const defaults = {
  airbrakeProjectId: 383870,
  airbrakeProjectKey: 'f9ea2f30ae7a11d8379d4f1dede2e0d4',
  storagePrefix: '_ts.',
  axs_client_id: '70_prj48sHE923ifje98dvn2lkjsdfoi2nskj23',
  axs_client_secret: 'anFH83kjdnf2PdLde1fn3jsnvk2ndj2f3sdn'
}

const envs = {};

envs.development = {
  ...defaults,

  questUrl: 'http://localhost:3046',
  emberAppUrl: 'http://localhost:3001',
  reactAppUrl: 'http://localhost:3004',
  apiRoot: 'http://localhost:3000',
  embedSdk: 'http://localhost:8181/ts-embed.debug.js',

  gaMeasurementId: 'G-6RNHWRZNKT',
  googleKey: 'AIzaSyCEs-seZjKeDPpvXfY87shqNqvcDLg8wUQ',
  facebookAppId: '384503444962200',
  reCaptchaKey: '6LeF0VUUAAAAAOWhQo5kPUfZHghkn0fQJvxLMIzq',
  authorizeNetPaymentUrl: 'https://test.authorize.net/payment/payment',
  env: 'development'
};

envs.staging = {
  ...defaults,

  questUrl: 'https://quest.stagingspeak.com',
  emberAppUrl: 'https://www.stagingspeak.com',
  reactAppUrl: 'https://www.stagingspeak.com',
  apiRoot: 'https://api.stagingspeak.com',
  embedSdk: '//cdn.stagingspeak.com/sdk/v1/ts-embed.js',

  gaMeasurementId: 'G-9VM42JXRTX',
  googleKey: 'AIzaSyAGdyvqg8Au0yjyl-VQ9Getc8wEb74-VD4',
  facebookAppId: '504832369535061',
  reCaptchaKey: '6LdD0VUUAAAAAJgn9eegBIxSErpuF3OGMEle-7gO',
  authorizeNetPaymentUrl: 'https://test.authorize.net/payment/payment',
  env: 'staging'
};

envs.production = {
  ...defaults,

  questUrl: 'https://quest.tunespeak.com',
  emberAppUrl: 'https://www.tunespeak.com',
  reactAppUrl: 'https://www.tunespeak.com',
  apiRoot: 'https://api.tunespeak.com',
  embedSdk: '//cdn.tunespeak.com/sdk/v1/ts-embed.js',

  gaMeasurementId: 'G-J2NX2YPE4L',
  googleKey: 'AIzaSyD5aIrE5n2wo8XxqT7p0iMIX0T6YbIrhpA',
  facebookAppId: '116527605044984',
  reCaptchaKey: '6LdE0VUUAAAAAD8XBQwxCj3r2w_lUgfjJDUTKRjG',
  authorizeNetPaymentUrl: 'https://accept.authorize.net/payment/payment',
  env: 'production'
};

envs.beta = {
  ...envs.production,

  questUrl: 'https://beta-quest.tunespeak.com',
  emberAppUrl: 'https://beta.tunespeak.com',
  reactAppUrl: 'https://beta.tunespeak.com',
  apiRoot: 'https://beta-api.tunespeak.com',
  env: 'beta'
}

export default envs[process.env.REACT_APP_ENV || 'development'];
